import customerFileApi from '@/api/customerFile';
import { loadEntity } from '@/helpers/utility';

const state = {
    byId: {},
};

const actions = {
    async createCustomerFile(store, { customer, customerFile, onUploadProgress }) {
        customerFile = await customerFileApi.store(customer, customerFile, onUploadProgress);
        loadEntity({ customerFile });
        return customerFile;
    },
    async updateCustomerFile(store, { customerFile }) {
        customerFile = await customerFileApi.update(customerFile);
        loadEntity({ customerFile });
        return customerFile;
    },
    async deleteCustomerFile({ commit }, { customerFile }) {
        await customerFileApi.delete(customerFile);
        commit('DELETE_CUSTOMERFILE', { id: customerFile.id });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { customerFiles }) {
        if (customerFiles)
            Object.values(customerFiles).forEach(customerFile => Vue.set(state.byId, customerFile.id, customerFile));
    },
    DELETE_CUSTOMERFILE(state, { id }) {
        Vue.delete(state.byId, id);
    },
};

export default {
    state,
    actions,
    mutations,
};
